<template>
	<div>
		<v-tabs v-model="tab" align-with-title>
			<v-tabs-slider color="secondary"></v-tabs-slider>
			<v-tab>Jobs</v-tab>
			<v-tab v-if="$can('archiveJob')">Archived</v-tab>
		</v-tabs>
		<keep-alive>
			<component 
				:is="currentTabComponent" 
				:latest-job="newJob"
				@open="openJobInfo" 
				@archive="toggleArchivePrompt" 
				@cancel="toggleCancelPrompt"
			/>
		</keep-alive>
		<v-fab-transition>
			<v-btn v-if="$can('createFirmwareUpdateJob') || $can('createDeviceConfigJob') || $can('createDeviceInstallJob')" color="primary" class="screen-fixed" fixed right fab x-large @click="addJob">
				<v-icon>mdi-clipboard-list</v-icon>
			</v-btn>
		</v-fab-transition>

		<add-job 
			:open="modal" 
			:mode="mode" 
			@latestJob="handleLatestJob"
			@exit="modal = false"
		/>

		<read-only-job 
			:display="displayReadOnly"
			:job="selectedJob"
			@exit="displayReadOnly = false"
		/>

		<Prompt
			:display="cancelJobConfirm"
			:close-target="'closeCancelJob'"
			:submit-target="'submitCancelJob'"
			:title="'Cancel Job'"
			:message="'Are you sure you wish to cancel this job?'"
			:state="cancelState" 
			:res="cancelRes"
			@closeCancelJob="toggleCancelPrompt"
			@submitCancelJob="cancel"
		/>

		<Prompt
			:display="archiveJobConfirm"
			:close-target="'closeCancelJob'"
			:submit-target="'submitCancelJob'"
			:title="'Archive Job'"
			:message="'Are you sure you wish to archive this job?'"
			:state="archiveState" 
			:res="archiveRes"
			@closeCancelJob="toggleArchivePrompt"
			@submitCancelJob="archive"
		/>


	</div>
</template>

<script>

	import { UpdateJob, DeleteJob } from "@/services/API.js";

	import { AmplifyEventBus } from "aws-amplify-vue";
	// import moment from "moment";
	import { mapActions } from "vuex";

	import { Logger } from "aws-amplify";
	const logger = new Logger("Jobs");

	import JobsNow from "./Sections/JobsNow.vue";
	import JobsOld from "./Sections/JobsOld.vue";
	import AddJob from "./Sections/AddJob.vue";
	import ReadOnlyJob from './Sections/ReadOnlyJob.vue';
	import Prompt from '@/components/general/Prompt.vue';

	export default {
		components: {
			JobsNow,
			JobsOld,
			AddJob,
			ReadOnlyJob,
			Prompt
		},
		data: () => ({
			tab: 0,
			mode: "new",
			modal: false,
			items: ["Jobs", "Archived"],
			displayReadOnly: false,
			selectedJob: {},
			cancelJobConfirm: false,
			cancelState: false,
			cancelRes: null,
			cancelTarget: {},
			archiveJobConfirm: false,
			archiveState: false,
			archiveRes: null,
			archiveTarget: {},
			newJob: {}
		}),
		computed: {
			currentTabComponent: function() {
				logger.debug(this);
				switch (this.tab) {
					case 0:
						return "jobs-now";
					case 1:
						return "jobs-old";
					default:
						return "jobs-now";
				}
			}
		},
		mounted() {
			this.getOrgs();
			this.getUsers();
			this.getVehiType();
		},
		methods: {
			...mapActions(["getOrgs", "getUsers", "getVehiType"]),
			handleLatestJob(job) {
				this.newJob = job;
			},
			addJob() {
				this.mode = "new";
				this.modal = true;
			},
			open(item) {
				this.mode = Object.assign({}, item);
				this.modal = true;
			},
			openJobInfo(item) {
				this.selectedJob = item;
				this.displayReadOnly = true;
			},
			async archive() {
				logger.debug("Archive", this.archiveTarget);
			
				const params = {
					archived: true
				};
				const res = await UpdateJob(this.archiveTarget.id, params);

				if (res) {
					this.archiveState = true;
					this.archiveRes = {
						msg: `Job ${this.archiveTarget.name} has been archived`,
						code: 'green'
					};

					AmplifyEventBus.$emit("job-now", {
						action: "remove",
						job: res
					});
				}
				else {
					this.archiveState = true;
					this.archiveRes = {
						msg: `An error has occurred`,
						code: 'red'
					};
				}
			},
			toggleCancelPrompt(item) {
				this.cancelState = false;
				this.cancelRes = null;
				this.cancelTarget = item;
				this.cancelJobConfirm = !this.cancelJobConfirm;
			},
			toggleArchivePrompt(item) {
				this.archiveState = false;
				this.archiveRes = null;
				this.archiveTarget = item;
				this.archiveJobConfirm = !this.archiveJobConfirm;
			},
			async cancel() {
				logger.debug("Cancel", this.cancelTarget);
				const key = this.cancelTarget.Tasks[0].task_type;
				const map = {
					taskinstall: 'otc_job',
					device_config: 'device_config_job',
					firmwareupdate: 'firmware_job'
				};
				const params = {
					job_type: map[key]
				};
				const res = await DeleteJob(this.cancelTarget.id, params);
				
				if (res) {
					this.cancelState = true;
					this.cancelRes = {
						msg: `Job ${this.cancelTarget.name} has been cancelled`,
						code: 'green'
					};

					AmplifyEventBus.$emit("job-now", {
						action: "modify",
						job: res
					});
				}
				else {
					this.cancelState = true;
					this.cancelRes = {
						msg: `An error has occurred`,
						code: 'red'
					};
				}
			}
		}
	};
</script>